"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1746],{

/***/ 89844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ConfirmModal": function() { return /* binding */ ConfirmModal; },
  "DynamicConfirmModal": function() { return /* binding */ DynamicConfirmModal; },
  "default": function() { return /* binding */ modals_ConfirmModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/modals/ConfirmModal.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        " !important;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  button {\n    flex-grow: 1;\n    max-width: 50%;\n  }\n\n  @media (max-width: ",
        ") {\n    display: block;\n\n    button {\n      display: block;\n      width: 100%;\n      max-width: unset;\n      margin-bottom: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var iconVariants = {
    warning: {
        color: (0,theme/* color */.$_)("notice_500")
    },
    info: {
        color: (0,theme/* color */.$_)("info_500")
    }
};
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c5d3896-0"
})(_templateObject());
var StyledIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c5d3896-1"
})(_templateObject2(), (0,theme/* color */.$_)("notice_500"), (0,theme/* fontSize */.JB)("xl7"), function(param) {
    var variant = param.variant;
    return variant && iconVariants[variant] && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), iconVariants[variant].color);
});
var StyledTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-8c5d3896-2"
})(_templateObject3(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("midnight_500"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl3"));
var StyledText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8c5d3896-3"
})(_templateObject4(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c5d3896-4"
})(_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/modals/ConfirmModal.tsx










var ConfirmModal = function(param) {
    var isOpen = param.isOpen, close = param.close, title = param.title, text = param.text, action = param.action, actionId = param.actionId, confirmText = param.confirmText, cancelText = param.cancelText, _closeAfterConfirm = param.closeAfterConfirm, closeAfterConfirm = _closeAfterConfirm === void 0 ? true : _closeAfterConfirm, _icon = param.icon, icon = _icon === void 0 ? pro_light_svg_icons/* faWarning */.e7M : _icon, _iconVariant = param.iconVariant, iconVariant = _iconVariant === void 0 ? "warning" : _iconVariant;
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    var ref = (0,react.useState)(false), submitting = ref[0], setSubmitting = ref[1];
    var handleConfirmClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            action(actionId || 1)
                        ];
                    case 2:
                        _state.sent();
                        if (closeAfterConfirm) {
                            setSubmitting(false);
                            close();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        setSubmitting(false);
                        throw ex;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmClick() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (isOpen) {
            setSubmitting(false);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Modal */.u_, {
        buttonsFullWidth: true,
        closeable: false,
        isOpen: isOpen,
        title: "",
        buttonCancel: {
            onClick: close,
            label: cancelText || t("confirmModal.actions.cancel")
        },
        buttonSuccess: {
            onClick: handleConfirmClick,
            isLoading: submitting,
            label: confirmText || t("confirmModal.actions.confirm")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                variant: iconVariant,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: title || t("confirmModal.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                children: text || t("confirmModal.text")
            })
        ]
    });
};
/* harmony default export */ var modals_ConfirmModal = (ConfirmModal);
var DynamicConfirmModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 89844));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89844)
            ];
        }
    },
    ssr: false
});


/***/ }),

/***/ 71746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OfferAlertModal": function() { return /* binding */ OfferAlertModal; },
  "default": function() { return /* binding */ alerts_OfferAlertModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@auth0/nextjs-auth0/dist/client/index.js
var client = __webpack_require__(5778);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Button.styled.tsx
var Button_styled = __webpack_require__(59760);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./hooks/useToasts/useToasts.ts
var useToasts = __webpack_require__(57064);
// EXTERNAL MODULE: ./model/index.ts + 29 modules
var model = __webpack_require__(41400);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./services/service-offer-alert.ts + 2 modules
var service_offer_alert = __webpack_require__(33917);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(45455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./services/ui/offer.service.ts
var offer_service = __webpack_require__(58630);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(3716);
;// CONCATENATED MODULE: ./utils/job-offers-alerts.ts



var buildJobOfferAlertNameCriteria = function(param) {
    var filter = param.filter, techs = param.techs, techRoles = param.techRoles, t = param.t, locale = param.locale;
    var ref, ref1, ref2, ref3, ref4;
    return [
        {
            isFulfilled: !isEmpty_default()(filter.techRoles),
            text: ((ref = filter.techRoles) === null || ref === void 0 ? void 0 : ref.map(function(techRoleId) {
                return techRoles.find(function(tech) {
                    return tech.value === techRoleId;
                });
            }).map(function(techRole) {
                return techRole === null || techRole === void 0 ? void 0 : techRole.label;
            }).filter(Boolean).join(", ")) || ""
        },
        {
            isFulfilled: isEmpty_default()(filter.techRoles) && !isEmpty_default()(filter.text),
            text: filter.text
        },
        {
            isFulfilled: !isEmpty_default()(filter.locations) || !isEmpty_default()(filter.remoteOptions),
            text: "".concat(!isEmpty_default()(filter.locations) ? t("offerAlertModal.item.at", {
                value: getCityNames(filter.locations, locale)
            }) : "").concat(!isEmpty_default()(filter.locations) && !isEmpty_default()(filter.remoteOptions) ? " " + t("offerAlertModal.item.plus", {
                value: ((ref1 = filter.remoteOptions) === null || ref1 === void 0 ? void 0 : ref1.map(function(opt) {
                    return t("remote_options_items.".concat(opt), {
                        ns: "job-offer-list"
                    });
                }).join(", ")) || ""
            }) : ((ref2 = filter.remoteOptions) === null || ref2 === void 0 ? void 0 : ref2.map(function(opt) {
                return t("remote_options_items.".concat(opt), {
                    ns: "job-offer-list"
                });
            }).join(", ")) || "")
        },
        {
            isFulfilled: !isEmpty_default()(filter.techs),
            text: t("offerAlertModal.item.with", {
                value: ((ref3 = filter.techs) === null || ref3 === void 0 ? void 0 : ref3.map(function(techId) {
                    return techs.find(function(tech) {
                        return tech.value === techId;
                    });
                }).map(function(tech) {
                    return tech === null || tech === void 0 ? void 0 : tech.label;
                }).filter(Boolean).join(", ")) || ""
            })
        },
        {
            isFulfilled: !!filter.minSalary,
            text: t("offerAlertModal.item.for", {
                value: filter.minSalary,
                currency: filter.currency
            })
        },
        {
            isFulfilled: !isEmpty_default()(filter.minLanguages),
            text: t("offerAlertModal.item.minLanguages", {
                value: (ref4 = filter.minLanguages) === null || ref4 === void 0 ? void 0 : ref4.map(function(minLang) {
                    return "".concat(minLang.language.label, " (").concat(t("language-selector.level.options." + minLang.level.value, {
                        ns: "common"
                    }), ")");
                }).join(", ")
            })
        },
        {
            isFulfilled: !!filter.offerLanguage,
            text: t("offerAlertModal.item.in", {
                value: t("offerAlertModal.item.lang.".concat(filter.offerLanguage))
            })
        }
    ];
};
var getJobOfferAlertName = function(param) {
    var alert = param.alert, techs = param.techs, techRoles = param.techRoles, t = param.t, locale = param.locale, _criteriaCount = param.criteriaCount, criteriaCount = _criteriaCount === void 0 ? 3 : _criteriaCount;
    var criteria = buildJobOfferAlertNameCriteria({
        filter: alert.filter,
        techs: techs,
        techRoles: techRoles,
        t: t,
        locale: locale
    });
    if (criteria.length <= 0) {
        return "".concat(t("offerAlertModal.alert", {
            date: (0,date/* formatDateTime */.o0)(alert.createdAt, locale)
        }));
    }
    return criteria.filter(function(c) {
        return c.isFulfilled && !!c.text;
    }).map(function(c) {
        return c.text;
    }).slice(0, criteriaCount).join(" ").trim();
};
function getCityNames(cities, locale) {
    if (!cities) {
        return "";
    }
    var parsedCities = (0,offer_service/* getCityStringFromUIPlacesAutocompleteItem */.Wl)(cities, locale).split(", ");
    return getArrayValue(parsedCities);
}
function getArrayValue() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], MAX_ELEMENTS = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var suffix = val.length > MAX_ELEMENTS ? " (+".concat(val.length - MAX_ELEMENTS, ")") : "";
    return "".concat(val === null || val === void 0 ? void 0 : val.slice(0, MAX_ELEMENTS).join(", ")).concat(suffix);
}

// EXTERNAL MODULE: ./utils/job-offers-filter.ts
var job_offers_filter = __webpack_require__(55920);
// EXTERNAL MODULE: ./utils/localize.utils.ts
var localize_utils = __webpack_require__(38062);
// EXTERNAL MODULE: ./components/modals/ConfirmModal.tsx + 1 modules
var ConfirmModal = __webpack_require__(89844);
// EXTERNAL MODULE: ./components/shared/Modal.tsx
var Modal = __webpack_require__(61897);
// EXTERNAL MODULE: ./features/job-offers/list/components/JobOffersListComponent.constants.ts
var JobOffersListComponent_constants = __webpack_require__(82324);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/job-offers/list/components/alerts/OfferAlertModal.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-align: center;\n\n  p {\n    margin: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    padding: ",
        ";\n    margin-top: 0;\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    line-height: 1.2;\n    color: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  padding: ",
        " 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n\n  &:first-letter {\n    text-transform: uppercase;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f9fee673-0"
})(_templateObject(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), Button_styled/* default */.Z, (0,theme/* spacing */.W0)("lg"));
var StyledEmptyIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f9fee673-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("midnight_300"));
var StyledEmptyTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-f9fee673-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("md"));
var StyledOfferAlertItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f9fee673-3"
})(_templateObject3(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("md"));
var StyledOfferAlertItemContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f9fee673-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./features/job-offers/list/components/alerts/OfferAlertModal.tsx

























var OfferAlertModal = function(param) {
    var offerAlerts = param.offerAlerts, techs = param.techs, techRoles = param.techRoles, setOfferAlerts = param.setOfferAlerts, close = param.close, isOpened = param.isOpened, unsuscribeActionOfferAlert = param.unsuscribeActionOfferAlert, onCreateAlertClick = param.onCreateAlertClick, userCanCreateAlerts = param.userCanCreateAlerts;
    var t = (0,useI18n/* useI18n */.Q)("offer-alert-modal").t;
    var user = (0,client/* useUser */.aF)().user;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,useToasts/* useToasts */.e)(), addErrorToast = ref.addErrorToast, addSuccessToast = ref.addSuccessToast;
    var ref1 = (0,react.useState)(), isRemoving = ref1[0], setIsRemoving = ref1[1];
    var ref2 = (0,react.useState)(false), isConfirmModalOpened = ref2[0], setIsConfirmModalOpened = ref2[1];
    var toDeleteAlert = (0,react.useRef)();
    (0,react.useEffect)(function() {
        if (unsuscribeActionOfferAlert) {
            setIsConfirmModalOpened(true);
        }
    }, [
        unsuscribeActionOfferAlert
    ]);
    var handleDeleteClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, alertId, ex, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        alertId = ((ref = toDeleteAlert.current) === null || ref === void 0 ? void 0 : ref.id) || unsuscribeActionOfferAlert;
                        if (!alertId) return [
                            3,
                            2
                        ];
                        setIsRemoving(alertId);
                        return [
                            4,
                            service_offer_alert/* default.remove */.Z.remove(alertId)
                        ];
                    case 1:
                        _state.sent();
                        setOfferAlerts(offerAlerts.filter(function(alert) {
                            return alertId !== alert.id;
                        }));
                        setIsRemoving(undefined);
                        toDeleteAlert.current = undefined;
                        addSuccessToast(t("offerAlertModal.messages.success.delete"));
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        if ((0,_instanceof/* default */.Z)(ex, model/* FetchError */.kp) && ex.statusCode >= 500) {
                            ;
                            console.error("Could not delete Manfredite alert with ID: ".concat(((ref1 = toDeleteAlert.current) === null || ref1 === void 0 ? void 0 : ref1.id) || unsuscribeActionOfferAlert, ". Exception: ").concat(ex), ex);
                        }
                        addErrorToast(t("offerAlertModal.messages.error.delete"));
                        toDeleteAlert.current = undefined;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                isOpen: isOpened,
                contentLabel: t("offerAlertModal.title"),
                onRequestClose: close,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    onClose: close,
                    title: t("offerAlertModal.title"),
                    children: offerAlerts.length <= 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmpty, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmptyIcon, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    size: "4x",
                                    icon: pro_light_svg_icons/* faEmptySet */.ImE
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column",
                                gap: "xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmptyTitle, {
                                        children: t("offerAlertModal.messages.info.no-results.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("offerAlertModal.messages.info.no-results.text")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                            sizes: "xs",
                                            variant: "primary",
                                            onClick: onCreateAlertClick,
                                            disabled: !userCanCreateAlerts,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faBellPlus */.t$x
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("offerAlertModal.messages.info.no-results.cta")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                            size: "xs",
                                            variant: "hard",
                                            schema: "neutral",
                                            label: t("offerAlertModal.messages.info.no-results.register"),
                                            startIcon: pro_solid_svg_icons/* faUserAstronaut */.KCX,
                                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?returnUrl=").concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.jobOffers */.uu.jobOffers, locale))
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: offerAlerts.map(function(alertItem) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOfferAlertItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferAlertItemContent, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.jobOffers */.uu.jobOffers, locale), "?").concat((0,job_offers_filter/* getUrlParamsFromJobOffersFilter */.Ci)(alertItem.filter, (0,localize_utils/* getLocale */.K)(locale), [
                                                JobOffersListComponent_constants/* UNSUSCRIBE_ALERT_PARAM */.P4
                                            ])),
                                            children: getJobOfferAlertName({
                                                alert: alertItem,
                                                techs: techs,
                                                techRoles: techRoles,
                                                t: t,
                                                locale: locale
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                        isIcon: true,
                                        sizes: "sm",
                                        isLoading: isRemoving === alertItem.id,
                                        variant: "tertiaryNegative",
                                        onClick: function() {
                                            toDeleteAlert.current = alertItem;
                                            setIsConfirmModalOpened(true);
                                        },
                                        children: [
                                            isRemoving !== alertItem.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faTrash */.XAH
                                            }),
                                            isRemoving === alertItem.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faSpinnerThird */.AX7,
                                                spin: true
                                            })
                                        ]
                                    })
                                ]
                            }, alertItem.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModal["default"], {
                isOpen: isConfirmModalOpened,
                close: function() {
                    return setIsConfirmModalOpened(false);
                },
                action: handleDeleteClick,
                title: t("offerAlertModal.confirm-delete.title", {
                    alert: toDeleteAlert.current ? getJobOfferAlertName({
                        alert: toDeleteAlert.current,
                        techs: techs,
                        techRoles: techRoles,
                        t: t,
                        locale: locale,
                        criteriaCount: 2
                    }).charAt(0).toUpperCase() + getJobOfferAlertName({
                        alert: toDeleteAlert.current,
                        techs: techs,
                        techRoles: techRoles,
                        t: t,
                        locale: locale,
                        criteriaCount: 2
                    }).slice(1) : ""
                }),
                text: t("offerAlertModal.confirm-delete.text"),
                confirmText: t("offerAlertModal.confirm-delete.action-confirm"),
                cancelText: t("offerAlertModal.confirm-delete.action-cancel")
            })
        ]
    });
};
/* harmony default export */ var alerts_OfferAlertModal = (OfferAlertModal);


/***/ }),

/***/ 3716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NC": function() { return /* binding */ formatDateMonthYear; },
/* harmony export */   "V9": function() { return /* binding */ sortDateDesc; },
/* harmony export */   "Xn": function() { return /* binding */ monthDiff; },
/* harmony export */   "hp": function() { return /* binding */ sortByDateToAndFrom; },
/* harmony export */   "jm": function() { return /* binding */ isSameDateYearAndMonth; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50930);

function formatDateMonthYear(date, locale) {
    if (!date) {
        return "";
    }
    return new Intl.DateTimeFormat(locale || "en", {
        year: "numeric",
        month: "short"
    }).format(typeof date === "string" ? new Date(date) : date);
}
function formatDate(date, locale) {
    if (!date) {
        return "";
    }
    return new Intl.DateTimeFormat(locale || "en").format(typeof date === "string" ? new Date(date) : date);
}
function formatDateTime(date, locale) {
    if (!date) {
        return "";
    }
    return new Intl.DateTimeFormat(locale || "en", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    }).format(typeof date === "string" ? new Date(date) : date);
}
function monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months + 1;
}
/**
 * Sort the given values by the next criteria:
 *
 * - First: all the elements without dateTo, sorted by dateFrom descending
 * - Second: all the elements with dateTo, sorted by dateTo descending
 *
 * @param values array of values to be sorted
 * @returns a new array with the values sorted
 */ function sortByDateToAndFrom(values) {
    var current = values.filter(function(i) {
        return !i.dateTo;
    }).sort(function(a, b) {
        return sortDateDesc(a.dateFrom, b.dateFrom);
    });
    var ended = values.filter(function(i) {
        return !!i.dateTo;
    }).sort(function(a, b) {
        return a.dateTo && b.dateTo ? sortDateDesc(a.dateTo, b.dateTo) : 0;
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(current).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ended));
}
function sortDateDesc(a, b) {
    var aDate = new Date(a);
    var bDate = new Date(b);
    if (aDate.getTime() > bDate.getTime()) {
        return -1;
    }
    if (aDate.getTime() < bDate.getTime()) {
        return 1;
    }
    return 0;
}
function isSameDateYearAndMonth(a, b) {
    if (!a || !b) {
        throw new Error("You must pass a date");
    }
    var aDate = new Date(a);
    var bDate = new Date(b);
    return aDate.getFullYear() === bDate.getFullYear() && aDate.getMonth() === bDate.getMonth();
}


/***/ })

}]);